module.exports = __webpack_public_path__ + "static/media/down.b68cdba8.svg";